import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export function getToken() {
  try {
    const storage = localStorage.getItem("auth-storage");
    if (!storage) return null;

    const parsed = JSON.parse(storage);
    return parsed?.state?.accessToken ?? null;
  } catch (err) {
    console.error("Failed to parse token:", err);
    return null;
  }
}
